import { injectIntl } from "react-intl";
import { Modal } from "react-bootstrap";
import intlShape from "../../shapes/intlShape";
import InstrumentationDuplicateOneTag from "./InstrumentationDuplicateOneTag";
import InstrumentationDuplicateMoreTags from "./InstrumentationDuplicateMoreTags";
import { BadRequestError } from "../../api";
import {
  apiShape,
  browserShape,
  notifierShape,
  withApi,
  withBrowser,
  withNotifier,
} from "../../context";

type Props = {
  intl: intlShape;
  onCloseDuplicate?: $TSFixMeFunction;
  onCreateDuplicate?: $TSFixMeFunction;
  duplicateTags: {
    id?: number;
    tag?: string;
  }[];
  assetId: string;
  notifier: notifierShape;
  api: apiShape;
  browser: browserShape;
};

export function InstrumentationDuplicateModal({
  intl,
  onCloseDuplicate,
  onCreateDuplicate,
  duplicateTags,
  assetId,
  notifier,
  browser,
  api,
}: Props) {
  const onAssignDuplicate = async (values: $TSFixMe) => {
    try {
      await api.post(`/instrumentations/${values.tag.id}/assets`, {
        assets: [{ id: assetId }],
      });
      notifier.showSuccess(
        intl.formatMessage({
          id: "instrumentation.actions.assign.notification",
        }),
      );
      browser.navigateTo(`/instrumentations/${values.tag.id}`);
    } catch (error) {
      if (
        error instanceof BadRequestError &&
        // @ts-expect-error TS(2345) FIXME: Argument of type '"assets"' is not assignable to p... Remove this comment to see the full error message
        error.contains("associations_already_added", "assets")
      ) {
        notifier.showError(
          intl.formatMessage({ id: "instrumentation.actions.assign.error" }),
        );
      } else {
        notifier.showError(api.translateError(error));
      }
    }
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onCloseDuplicate();
  };

  return (
    <Modal
      id="duplicate-instrumentation-modal"
      dialogClassName="duplicate-instrumentation"
      show
      restoreFocus={false}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      size="sm"
      backdrop="static"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="duplicate-instrumentation-title">
          {intl.formatMessage({
            id: "instrumentation_assign.duplicate_modal_title",
          })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-duplicate-tag">
        <div id="duplicate-instrumentation-message" className="space-after">
          {duplicateTags.length === 1 ? (
            <InstrumentationDuplicateOneTag
              // @ts-expect-error TS(2322) FIXME: Type '{ id: string; intl: intlShape; onCreateDupli... Remove this comment to see the full error message
              id="instrumentation-duplicate-one-tag"
              intl={intl}
              onCreateDuplicate={onCreateDuplicate}
              onCloseDuplicate={onCloseDuplicate}
              duplicateTags={duplicateTags}
              onAssignDuplicate={onAssignDuplicate}
            />
          ) : (
            <InstrumentationDuplicateMoreTags
              // @ts-expect-error TS(2322) FIXME: Type '{ id: string; intl: intlShape; onCreateDupli... Remove this comment to see the full error message
              id="instrumentation-duplicate-more-tags"
              intl={intl}
              onCreateDuplicate={onCreateDuplicate}
              onCloseDuplicate={onCloseDuplicate}
              duplicateTags={duplicateTags}
              onAssignDuplicate={onAssignDuplicate}
            />
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default injectIntl(
  withBrowser(withNotifier(withApi(InstrumentationDuplicateModal))),
);
